export class SrpValidationPatterns {
    /// Patterns
    static emailPattern = /^[A-Za-z0-9'._-]+([\/'._-][A-Za-z0-9]+)*@[A-Za-z0-9]+([\.-][A-Za-z0-9]+)*(\.[A-Za-z0-9]{2,10})+$/;
    static phoneSymbol = /^[ 0-9&+-]*$/;
    static phonePattern = /[\d]{3,3}-[\d]{3,3}-[\d]{4,4}/;
    static phoneInternationalPattern = /^(?=.*[0-9])[- +&0-9()]+$/;
    static userCodePattern = /^[a-zA-Z0-9-_]{0,3}$/;
    static zipCodePattern = /[\d]{5,5}/;
    static passwordValidator = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[`~!@#$%^&*()\-_=+\[\]{}\\|:;"'<>,.?\/]).{6,}$/;
    static numberPattern = /^\d+(?:[\.|\,]\d{1,3})?$/;
    static floatSignedNumber = /^-?\d+\.?\d*$/;
    static floatNumber = /^\d+\.?\d*$/;
    static patternForTenantCode = /^[a-zA-Z0-9 _.-]*$/;
    static fileNamePattern = /^[^<>:?"*|\\/]+$/;
    static excludeAllSpecialSymbols = /^[a-zA-Z0-9]*$/;
    static anyWhitespace = /^[^\s\uFEFF\xA0]+$/;

    /// Methods
    static checkTenantCodeValidity(data: string): boolean {
        return SrpValidationPatterns.patternForTenantCode.test(data);
    }
    static checkEmailValidity(email: string): boolean {
        return SrpValidationPatterns.emailPattern.test(email);
    }

    static checkPhoneValidity(phone: string, isNationale = true): boolean {
        let result = false;
        if (isNationale) {
            result = SrpValidationPatterns.phonePattern.test(phone);
        } else {
            result = SrpValidationPatterns.phoneInternationalPattern.test(phone);
        }
        return result;
    }

    static checkUserCodeValidity(userCode: string): boolean {
        return SrpValidationPatterns.userCodePattern.test(userCode);
    }

    static checkZipCodeValidity(zipCode: string): boolean {
        return SrpValidationPatterns.zipCodePattern.test(zipCode);
    }

    static checkNumberValidity(data: string): boolean {
        return SrpValidationPatterns.numberPattern.test(data);
    }

    static checkFileNameValidity(data: string): boolean {
        return SrpValidationPatterns.fileNamePattern.test(data);
    }

    static excludeSpecialSymbolsValidity(data: string): boolean {
        return SrpValidationPatterns.excludeAllSpecialSymbols.test(data);
    }

}